import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Typography } from '@mui/material';

// =============================================================================
// Types
// =============================================================================

interface ImportCompleteSummaryProps {
  importedCount: number;
  failedCount: number;
}

// =============================================================================
// Component
// =============================================================================

export const ImportCompleteSummary = ({
  importedCount,
  failedCount,
}: ImportCompleteSummaryProps) => {
  const navigate = useNavigate();
  const hasFailures = failedCount > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        py: 6,
      }}
    >
      {hasFailures ? (
        <WarningIcon sx={{ fontSize: 48, color: 'warning.main' }} />
      ) : (
        <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main' }} />
      )}

      <Typography variant="h5" fontWeight={600}>
        Import Complete
      </Typography>

      <Typography variant="body1" color="text.secondary">
        <Typography
          component="span"
          variant="body1"
          fontWeight={700}
          color="success.main"
        >
          {importedCount}
        </Typography>
        {' '}patients imported
        {hasFailures && (
          <>
            {' · '}
            <Typography
              component="span"
              variant="body1"
              fontWeight={700}
              color="error.main"
            >
              {failedCount}
            </Typography>
            {' '}failed
          </>
        )}
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate('/patients')}
        sx={{ mt: 1 }}
      >
        Go to Patients
      </Button>
    </Box>
  );
};

